import { render, staticRenderFns } from "./component.vue?vue&type=template&id=5d492584&scoped=true&lang=pug"
var script = {}
import style0 from "./component.vue?vue&type=style&index=0&id=5d492584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d492584",
  null
  
)

export default component.exports